export default __webpack_public_path__ + "static/media/successImg.0285241b.png";